export function previousStageForReview(custom: Record<string, unknown> | null | undefined): string | null {
  const value = custom?.pipeline_stage_review;
  return typeof value === 'string' && value.trim() ? value : null;
}

export function stagesForDealPipeline(verticalId: number | undefined, verticals: readonly { id: number; settings?: { deal_stages?: string[] } | null }[] | undefined, fallback: string[]): string[] {
  const configured = verticals?.find(vertical => vertical.id === verticalId)?.settings?.deal_stages;
  return configured?.length ? configured : fallback;
}
